// removed by extract-text-webpack-plugin
module.exports = {"text-box":"OptionsTextBox__text-box__37Hz-","header":"OptionsTextBox__header__3X1rA","content":"OptionsTextBox__content__Iea-K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuiteKey/Options/OptionsTextBox.scss
// module id = 401
// module chunks = 0